import React from 'react';
export function CostTable() {
  const comparisons = [{
    aspect: 'Horas armando material',
    without: '8hs/semana',
    with: '1h/semana'
  }, {
    aspect: 'Calidad de planificación',
    without: 'Irregular',
    with: 'Profesional y consistente'
  }, {
    aspect: 'Informes',
    without: 'Fin de semana entero',
    with: '30 minutos con plantilla'
  }, {
    aspect: 'Estrés dominical',
    without: 'Alto',
    with: 'Mínimo'
  }, {
    aspect: 'Adaptaciones',
    without: 'Improvisadas',
    with: 'Planificadas por nivel'
  }, {
    aspect: 'Costo en tiempo al año',
    without: '+300 horas perdidas',
    with: 'Material listo por $27990'
  }];
  return <section className="w-full py-8 bg-[#111111]" data-id="element-75">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-77">
          ¿Cuánto te cuesta NO tenerlo?
        </h2>
        <div className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg overflow-hidden" data-id="element-78">
          <div className="overflow-x-auto" data-id="element-79">
            <table className="w-full" data-id="element-80">
              <thead data-id="element-81">
                <tr className="bg-[#222222] border-b border-[#333333]" data-id="element-82">
                  <th className="px-6 py-4 text-left font-semibold text-white" data-id="element-83">
                    Aspecto
                  </th>
                  <th className="px-6 py-4 text-left font-semibold text-red-500" data-id="element-84">
                    Sin el MegaPack
                  </th>
                  <th className="px-6 py-4 text-left font-semibold text-[#D4A843]" data-id="element-85">
                    Con el MegaPack
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-86">
                {comparisons.map((item, index) => <tr key={index} className={index % 2 === 0 ? 'bg-[#1A1A1A]' : 'bg-[#151515]'} data-id="element-87">
                    <td className="px-6 py-4 font-medium text-gray-300 border-t border-[#2A2A2A]" data-id="element-88">
                      {item.aspect}
                    </td>
                    <td className="px-6 py-4 text-gray-400 border-t border-[#2A2A2A]" data-id="element-89">
                      {item.without}
                    </td>
                    <td className="px-6 py-4 text-[#E8C55A] font-semibold border-t border-[#2A2A2A]" data-id="element-90">
                      {item.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-5 text-center" data-id="element-91">
          <p className="text-xl text-gray-400" data-id="element-92">
            Cada domingo que pasás armando material desde cero es tiempo que
            nunca recuperás.
          </p>
          <p className="text-2xl font-bold text-[#D4A843] mt-4" data-id="element-93">
            ¿Cuánto vale tu tiempo?
          </p>
        </div>
      </div>
    </section>;
}